var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"shrink":""}},[_c('v-flex',{staticClass:"gst-event__venue-img"},[_c('EventTicketVenueImage',{staticClass:"u-mouse-pointer",attrs:{"image-props":{
                src: _vm.venueImageUrl,
                height: _vm.$vuetify.breakpoint.mdAndUp ? 247 : '20vh',
                width: '100%',
                contain: true,
                'aspect-ratio': 1,
            },"image-url-no-seats":_vm.imageUrlNoSeats,"loading":_vm.loading}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }